// extracted by mini-css-extract-plugin
export var button = "_nl-2";
export var card = "_nl-0";
export var closeButtonContainer = "_nl-3";
export var iconContainer = "_nl-1";